import { createContext, useContext } from 'react'
import { ExecutionBarConfig, MFExecutionData } from '../../types/mf-execution.types'

interface MFExecutionContextType {
  mfExecutionData: MFExecutionData
  isMFExecutionDataLoading: boolean
  isMFExecutionDataError: boolean
  isActionsSheetOpen: boolean
  isInfoSheetOpen: boolean
  executionBarZIndex: number
  executionBarConfig: ExecutionBarConfig
  mfExecutionDataRefetch: () => void
}

export const MFExecutionContext = createContext<MFExecutionContextType | undefined>(undefined)

export const useMFExecutionContext = () => {
  const context = useContext(MFExecutionContext)
  if (!context) {
    throw new Error('useMFExecutionContext must be used within a MFExecutionProvider')
  }
  return context
}
